export const GET_GETSIONI_NUMERI_NERI_GRUPPI_DATA_AND_LOADING =
  "GET_GETSIONI_NUMERI_NERI_GRUPPI_DATA_AND_LOADING";
export const CREATE_GRUPPI_DI_NUMERI_NERI_DATA =
  "CREATE_GRUPPI_DI_NUMERI_NERI_DATA";
export const CREATE_UPDATE_DELETE_GRUPPI_NUMERI_NERI =
  "CREATE_UPDATE_DELETE_GRUPPI_NUMERI_NERI";
export const GET_CURRENT_GROUP = "GET_CURRENT_GROUP";
export const EXPORT_GRUPPI_NUMERI_NERI_LOADING =
  "EXPORT_GRUPPI_NUMERI_NERI_LOADING";
